/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import OrganizationsOrganization from './OrganizationsOrganization';

/**
 * The OrganizationsBody model module.
 * @module model/OrganizationsBody
 * @version v0.3
 */
export default class OrganizationsBody {
  /**
   * Constructs a new <code>OrganizationsBody</code>.
   * @alias module:model/OrganizationsBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>OrganizationsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/OrganizationsBody} obj Optional instance to populate.
   * @return {module:model/OrganizationsBody} The populated <code>OrganizationsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new OrganizationsBody();
      if (data.hasOwnProperty('organization'))
        obj.organization = OrganizationsOrganization.constructFromObject(data['organization']);
    }
    return obj;
  }
}

/**
 * @member {module:model/OrganizationsOrganization} organization
 */
OrganizationsBody.prototype.organization = undefined;

